import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import anime from 'animejs';
import _ from 'lodash';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import Metadata from '../../helpers/metadata/Metadata';
import dataModel from '../../models/DataModel';
import PhotoUtil from '../../helpers/PhotoUtil/PhotoUtil';
import PhotoUtilPlugin from '../../helpers/PhotoUtilPlugin/PhotoUtilPlugin';
import FileUtil from '../../helpers/FileUtil/FileUtil';
import MiscConstants from '../../constants/MiscConstants';
import FileUploadPreview from '../../components/TaskCompletionStepsMobile/PhotoUpload/FileUploadPreview';
import TaskCompletionStepPhotoGrid from '../../components/TaskCompletionStepsMobile/PhotoUpload/TaskCompletionStepPhotoGrid';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import WaitSpinner from '../../components/WaitSpinner';
import PhotoCarouselPopup from '../../components/PhotoCarouselPopup';
import cameraIcon from '../../assets/images/photo-circle-blue.svg';
import CrewIssuesIcon from '../../assets/images/delays/CrewIssues.svg';
import DamagedEquipmentIcon from '../../assets/images/delays/DamagedEquipment.svg';
import DependencyIcon from '../../assets/images/delays/Dependency.svg';
import MissingEquipmentIcon from '../../assets/images/delays/MissingEquipment.svg';
import NatureIcon from '../../assets/images/delays/Nature.svg';
import RoadIcon from '../../assets/images/delays/Road.svg';
import SiteAccessIcon from '../../assets/images/delays/SiteAccess.svg';
import WeatherIcon from '../../assets/images/delays/Weather.svg';
import OtherIcon from '../../assets/images/delays/Other.svg';

import './DelayReportContainer.scss';
import Textarea from '../../components/Textarea';

export class DelayReportContainer extends Component {

  constructor(props) {
    super(props);

    if (props.delay) {
      this.state = {
        iconSrc: props.iconSrc || '',
        delayType: props.delay.delay_type || '',
        delayText: props.delay.name || '',
        infoValue: props.delay.details,
        attachments: props.delay.attachments,
        readOnly: true,
        displayPhotoCarousel: false,
        previewFile: null,
      };
    }
    else {
      DelayReportContainer.propTypes = {
        project: PropTypes.object.isRequired,
      };

      this.state = {
        iconSrc: props.iconSrc || '',
        delayType: props.delayType || '',
        delayText: props.delayText || '',
        infoValue: '',
        attachments: [],
        displayUploadButtons: false,
        loading: false,
        displayPhotoCarousel: false,
        previewFile: null,
      };
    }

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({ currentRole, isMobile: !!window.cordova });
    this.onTextChange = this.onTextChange.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.submitDelay = this.submitDelay.bind(this);
    this.displayUploadButtons = this.displayUploadButtons.bind(this);
    this.handleMobileImage = this.handleMobileImage.bind(this);
    this.setNewAttachment = this.setNewAttachment.bind(this);
    this.handleSaveFileToState = this.handleSaveFileToState.bind(this);
    this.handlePhotoSelection = this.handlePhotoSelection.bind(this);
    this.handleMultipleFileSelection = this.handleMultipleFileSelection.bind(this);
    this.mapTypeToIcon = this.mapTypeToIcon.bind(this);
    this.handleUploadConfirm = this.handleUploadConfirm.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
  }

  mapTypeToIcon(delayType) {
    switch (delayType) {
    case 'crew_issues':
      return CrewIssuesIcon;
    case 'damaged_equipment':
      return DamagedEquipmentIcon;
    case 'dependency':
      return DependencyIcon;
    case 'missing_equipment':
      return MissingEquipmentIcon;
    case 'nature':
      return NatureIcon;
    case 'road':
      return RoadIcon;
    case 'site_access':
      return SiteAccessIcon;
    case 'weather':
      return WeatherIcon;
    case 'other':
      return OtherIcon;
    default:
      return OtherIcon;
    }
  }

  componentDidMount() {
    if (this.props.displayDelayId) {
      dataModel.delaysDAO.getDelay(this.props.displayDelayId, { recordDescriptor: { delay: { attachments: {} } } }).then(delay => {
        const iconSrc = this.mapTypeToIcon(delay.delay_type);
        this.setState({
          displayDelayId: this.props.displayDelayId,
          delayType: delay.delay_type,
          delayText: delay.name,
          infoValue: delay.details,
          attachments: delay.attachments,
          readOnly: true,
          iconSrc,
        });
      });
    }
    if (!this.state.readOnly && this.props.currentUser && (!this.props.currentUser.settings || !this.props.currentUser.settings.user_has__viewed_mobile_delays_announcement_delay_details_document)) {
      dataModel.showCircleGlobalModal(ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT_MULTIPLE, { side: 'all' });
    }
  }

  componentDidUpdate(prevProps) {
    const { delay, displayDelayId } = this.props;
    if (prevProps.displayDelayId != displayDelayId && displayDelayId) {
      dataModel.delaysDAO.getDelay(displayDelayId, { recordDescriptor: { delay: { attachments: {} } } }).then(delay => {
        const iconSrc = this.mapTypeToIcon(delay.delay_type);
        this.setState({
          displayDelayId: displayDelayId,
          delayType: delay.delay_type,
          delayText: delay.name,
          infoValue: delay.details,
          attachments: delay.attachments,
          readOnly: true,
          iconSrc,
        });
      });
    }
    else if (this.state.readOnly && prevProps.delay && prevProps.delay.attachments != delay.attachments) {
      this.setState({ attachments: delay.attachments });
    }
  }

  onTextChange(e) {
    if (!this.state.readOnly) {
      this.setState({ [e.target.name]: e.target.value });
    }
  }

  handleImageClick() {
    if (!this.state.readOnly) {
      this.props.history.goBack();
    }
  }

  submitDelay(e) {
    e.preventDefault();
    if (!this.state.createInProgress) {
      this.setState({ createInProgress: true });
      const { delayText, delayType, infoValue, attachments } = this.state;
      if (delayText) {
        this.analyticsLogger.logDelayEvent('DelaySubmitted', delayType);
        let delay = {
          name: delayText,
          delay_type: delayType,
          details: infoValue,
          project_id: this.props.project.id,
          created_at: new Date().toJSON(),
        };
        dataModel.delaysDAO.createDelay(delay, null, null).then(newDelay => {

          //in this use the new delay id to create attachments
          attachments.forEach(attachment => {
            attachment.attachable_id = newDelay.id;
            const eventMetadatum = attachment.eventMetadatum;
            delete attachment.eventMetadatum;
            dataModel.attachmentsDAO.createAttachment(attachment, eventMetadatum);
          });

          let isIos = navigator.userAgent ? /(iphone)/i.test(navigator.userAgent.toLowerCase()) : false;
          if (!isIos) {
            this.props.history.goBack({ newDelay });
          }
          this.props.history.goBack({ newDelay });
        });
      }
    }
  }

  async handleMultipleFileSelection(e) {
    e.preventDefault();
    const { attachments } = this.state;

    const files = e.target.files;

    if (!files.length) {
      return;
    }
    else if (attachments.length + files.length > MiscConstants.MAX_NUMBER_OF_PHOTOS) {
      PhotoUtil.showErrorModal(attachments, true);
    }
    else {
      this.handleSaveFileToState(files);
    }
  }

  async handleSaveFileToState(files) {
    this.analyticsLogger.logDelayEvent('DelayPhotoAdded');

    for (let fileToUpload of files) {
      const resizedFile = await PhotoUtilPlugin.handleResizeFile(fileToUpload, FileUtil.getExtension(fileToUpload.name), null, 'library');
      const { file, fileExtension, resizedImage, exifData } = resizedFile;
      resizedImage.filename = await PhotoUtil.processMobileImageResults(fileToUpload, fileExtension);
      this.setNewAttachment(file, resizedImage, exifData);
    }
  }

  setNewAttachment(file, resizedImage, exifData) {
    let attachments = [...this.state.attachments];
    let newAttachment = {};
    newAttachment.id = dataModel.attachmentsDAO.creationIndex;
    newAttachment.attachable_type = 'Delay';
    newAttachment.upload = resizedImage;
    newAttachment.name = file.name;
    newAttachment.eventMetadatum = Metadata.generateMetadatum({ exifData: exifData });
    // below is in case attachment is persisted across app restart while offline
    newAttachment.upload_name = newAttachment.upload.name;
    attachments.unshift(newAttachment);
    this.setState({ attachments, loading: false });
  }

  handlePhotoSelection(attachment=null) {
    //show photo caoursel
    this.setState({ selectedAttachment: attachment ? attachment.id : null });
  }

  /* RENDER FUNCTIONS */

  createPhotoCarousel() {
    const { attachments, selectedAttachment } = this.state;
    const { 
      carouselWidth, 
      carouselHeight, 
      carouselTop, 
      carouselPosition,
    } = this.props;
    const delay = {
      attachments: attachments,
    };

    return (
      <article className='photo-carousel-container'>
        <header className='photo-carousel-container__header'>
          <p 
            id='done-button'
            onClick={this.handlePhotoSelection}
          >
            Done
          </p>
          <p>Delay Details</p>
        </header>
        <PhotoCarouselPopup 
          item={delay} 
          selectedAttachment={selectedAttachment}
          isFullPage={true}
          width={carouselWidth ? carouselWidth : window.innerWidth}
          height={carouselHeight ? carouselHeight : (window.innerHeight - 48)}
          position={carouselPosition}
          top={carouselTop ? carouselTop : 48}
        />
      </article>
    );
  }

  /* PHOTO UPLOAD FUNCTIONS */
  displayUploadButtons() {
    if (!this.state.displayUploadButtons) {
      document.addEventListener('touchstart', this.handleClickOutside, false);
      anime({
        targets: '.photo-uploads-container',
        translateY: -200,
        easing: 'easeInOutCubic',
        duration: 200,
      });
    }
    else {
      document.removeEventListener('touchstart', this.handleClickOutside, false);
      anime({
        targets: '.photo-uploads-container',
        translateY: 200,
        easing: 'easeInOutCubic',
        duration: 200,
      });
    }
    this.setState({ displayUploadButtons: !this.state.displayUploadButtons });
  }

  handleMobileImage(e) {
    e.preventDefault();
    const uploadMethod = e.target.name;

    if (navigator && navigator.camera) {
      this.displayUploadButtons();
      PhotoUtilPlugin.captureMobileImage(uploadMethod, false, () => {
        this.setState({ loading: true });
      })
      .then((fileinfo) => {
        if (uploadMethod == 'library') {
          this.setState({ previewFile: fileinfo });
        } else {
          this.finishUpload(fileinfo);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
    }
  }

  finishUpload(fileinfo) {
    const { file, resizedImage, exifData } = fileinfo;
    this.setNewAttachment(file, resizedImage, exifData);
    this.handleUploadCancel();
  }

  handleUploadConfirm() {
    this.finishUpload(this.state.previewFile);
  }

  handleUploadCancel() {
    this.setState({ previewFile: null, loading: false });
  }

  render() {
    const {
      iconSrc,
      delayType,
      delayText,
      infoValue,
      readOnly,
      attachments,
      loading,
    } = this.state;

    let isButtonActive = delayText && !this.state.createInProgress ? ' report-btn--active' : '';

    return (
      <form className='delay-report-container' onSubmit={this.submitDelay} disabled={this.state.createInProgress || readOnly}>
        {loading && <WaitSpinner />}
        <section className='report-type'>
          <img
            className={readOnly ? 'image-read-only' : ''}
            src={iconSrc}
            alt={delayType + ' icon'}
            onClick={this.handleImageClick}
          />
          <label className='report-label report-type__label'>
            NAME
            <Textarea
              className={'report-input report-type__input' + (readOnly ? ' report-type__input--read-only' : '')}
              value={delayText}
              name='delayText'
              onChange={this.onTextChange}
              disabled={readOnly}
            />
          </label>
        </section>
        <section className='report-description'>
          <label className='report-label report-description__label' htmlFor='delay-description'>DETAILED INFORMATION</label>
          <div className={'description-container' + (readOnly ? ' description-container--read-only' : '')}>
            <Textarea
              className={'report-input description-container__textarea' + (readOnly ? ' description-container__textarea--read-only' : '')}
              id='delay-description'
              placeholder={!readOnly ? 'Enter a description of the delay' : ''}
              value={infoValue}
              name='infoValue'
              onChange={this.onTextChange}
              disabled={readOnly}
            />
            {
              (!readOnly && attachments.length < MiscConstants.MAX_NUMBER_OF_PHOTOS) &&
              <button
                className='description-container__upload'
                onClick={this.displayUploadButtons}
                type='button'
              >
                <img
                  src={cameraIcon}
                  alt='upload'
                />
              </button>
            }
          </div>
        </section>
        <section className={'attachments-container' + (readOnly ? ' read-only' : '')}>
          <TaskCompletionStepPhotoGrid
            handlePhotoSelection={this.handlePhotoSelection}
            pathname={'mobile/projects/:project_id/add-delay/report/photo-display/:photo_id'}
            attachments={attachments}
            maxPhotos={MiscConstants.MAX_NUMBER_OF_PHOTOS}
            isInspection={true}
          />
        </section>
        {
          !readOnly && (
            <div className='report-button-container'>
              <button
                className={'report-btn' + isButtonActive}
                type='submit'
              >
                SUBMIT DELAY
              </button>
            </div>
          )
        }
        {
          this.state.previewFile &&
          <FileUploadPreview
            fileToPreview={this.state.previewFile}
            handleUploadConfirm={this.handleUploadConfirm}
            handleUploadCancel={this.handleUploadCancel}
          />
        }
        {
          this.state.selectedAttachment && this.createPhotoCarousel()
        }
        <div className='photo-uploads-container' ref={el => this.uploadButtons = el}>
          <div className="photo-background-disable" />
          <div className="upload-options" id="upload-buttons">
            <div className="outerbox">
              <button
                name="library"
                ref="library"
                className="upload-button top-button"
                onClick={!dataModel.isOffline? this.handleMobileImage:null}
                type='button'
              >
                Upload File
              </button>
              <button
                name="camera"
                onClick={this.handleMobileImage}
                className="upload-button"
                type='button'
              >
                Use Camera
              </button>
            </div>
            <div className="cancel-button" onClick={this.displayUploadButtons}>
              Cancel
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};
export default withRouter(connect(mapStateToProps)(DelayReportContainer));



// WEBPACK FOOTER //
// ./src/containers/DelayReportContainer/index.js